import { Cancel, Save } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../../api2";
import Helper from "../../../helpers";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";

export function ThongTinCoSoCheBien({id}) {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const dataDanhMuc = common?.danhmucs?.data;
  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetCoSoCheBienById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(data);

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertCoSoCheBien({
        token: user.access_token,
        data: parseDataSave(formRef.current.values)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Thông tin cơ sở chế biến" }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            handleSave();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
